import styled from '@emotion/styled';

export const ChatOrderAgreementModalStyle = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 32px 32px 20px;
  width: 512px;
  border-radius: 16px;
  background-color: var(--seed-semantic-color-paper-default);

  .close-button {
    position: absolute;
    top: 14px;
    right: 20px;
    padding: 3px;
    border: none;
    background: none;
    cursor: pointer;
    color: var(--seed-scale-color-gray-600);
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: var(--seed-scale-color-gray-900);
      fill: var(--seed-scale-color-gray-900);
    }

    svg{
    fill: var(--seed-scale-color-gray-600);

    }
  }

  .icon-wrapper {
    width: 48px;
    height: 48px;
    margin-bottom: 8px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .header-label {
    font-size: 16px;
    font-weight: 700;
    color: var(--seed-scale-color-carrot-500);
  }

  .title {
    font-size: 24px;
    font-weight: 700;
    color: var(--seed-scale-color-gray-900);
    margin-bottom: 8px;
    line-height: 32px;
  }

  .description {
    font-size: 16px;
    color: #555D6D;
    line-height: 1.5;
    margin-bottom: 32px;
  }

  .agreement-section {
    padding-bottom: 32px;
    border-bottom: 1px solid var(--seed-semantic-color-divider-1);
  }

  .agreement-title {
    font-size: 18px;
    font-weight: 700;
    color: var(--seed-scale-color-gray-900);
    margin-bottom: 4px;
  }

  .agreement-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .agreement-item {
    display: flex;
    align-items: center;
    padding: 12px 0;
  }

  .check-button {
    border: none;
    background: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    flex: 1;
    padding: 0;
    text-align: left;

    .check-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }


    .item-label {
      flex: 1;
      font-size: 15px;
      color: var(--seed-scale-color-gray-900);
      margin-left: 12px;
    }
  }

  .arrow-button {
    border: none;
    background: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--seed-scale-color-gray-400);
    flex-shrink: 0;

    &:hover {
      color: var(--seed-scale-color-gray-600);
    }
  }

  .submit-button {
    align-self: flex-end;
    padding: 8px 16px;
    margin-top: 16px;
    border: none;
    border-radius: 6px;
    background-color: var(--seed-scale-color-gray-900);
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    line-height: 150%;
    cursor: pointer;
    transition: background-color 0.15s;

    &:hover:not(:disabled) {
      background-color: var(--seed-scale-color-gray-800);
    }

    &:disabled {
      background-color: var(--seed-scale-color-gray-300);
      cursor: not-allowed;
    }
  }
`;
